var _effectorFileName = "/src/page-content/individual-lessons/ui.tsx";
import { useTranslation } from 'next-i18next';
import { MainIndividualLessons } from '@/page-content/individual-lessons/components/main-individual-lessons';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { SERVICES_LIST } from '@/widgets/layouts/main/constants/services-list';
import { Pricing } from '@/widgets/layouts/main/pricing/pricing';
import { Reviews } from '@/widgets/layouts/main/reviews';
import { SliderCards } from '@/widgets/layouts/main/slider-cards';
import { PageSeo } from '@/shared/lib/seo';
import { CARDS } from '../group-lessons/constants/cards';
import { PlusesIndividualLessons } from './components/pluses-individual-lessons';
export const IndividualLessonsPage = () => {
  const {
    t
  } = useTranslation('individual-lessons-page');
  return <>
      <PageSeo title={t('seo.title')} description={t('seo.description')} />

      <MainIndividualLessons />

      <PlusesIndividualLessons />

      <SliderCards cards={CARDS} />

      <Reviews />

      <Pricing servicesList={SERVICES_LIST} />

      <CallToAction withForm />
    </>;
};
IndividualLessonsPage.Layout = MainLayout;